module.exports = __webpack_public_path__ + "static/media/student progress report.918cbc8a.svg";